import { Immutable } from "immer";
import React, { type JSX } from "react";

import NavFooterComp from "./NavFooterComp";
import { IMenuCategoryLink } from "./menu.interface";

type IProps = Immutable<{
    flinks: IMenuCategoryLink[];
}>;

const NavFooter = (props: IProps) => {
    let navFooterEle: JSX.Element | null = null;
    props.flinks.forEach((menuItem) => {
        if (menuItem.type !== "nav_category") {
            return;
        }
        if (menuItem.value.sub_nav.length > 0) {
            menuItem.value.sub_nav.forEach((val) => {
                switch (val.type) {
                    case "nav_footer":
                        navFooterEle = <NavFooterComp navFooterEl={val} />;
                        break;
                    default:
                        break;
                }
            });
        }
    });

    return navFooterEle;
};

export default NavFooter;
